<template>
  <div class="u-flex u-align-center">
    <blob-panel>
      <h2 class="text-center">
        Welcome to {{ provider.name }}!
      </h2>

      <form role="form" @submit.prevent="submit">
        <div class="form-group" :class="formClass('name')">
          <label for="name">Name</label>
          <input
            id="name"
            v-model="user.name"
            name="name"
            type="text"
            class="form-control"
            autocomplete="name"
            required
            autofocus
            @input="updateScore"
          >

          <span v-for="error in errors['name']" v-if="errors['name']" class="help-block"><strong v-text="error" /><br></span>
        </div>

        <div class="form-group" :class="formClass('email')">
          <label for="email">
            Email
          </label>
          <input
            id="email"
            v-model="user.email"
            name="email"
            type="email"
            readonly
            disabled
            class="form-control"
            autocomplete="email"
            required
            @input="updateScore"
          >
        </div>

        <div class="form-group" :class="formClass('password')">
          <label>Password</label>
          <vue-password
            v-model="user.password"
            name="password"
            autocomplete="password"
            placeholder="Password"
            :user-inputs="[user.name, user.email]"
            required
            @input="updateScore"
          />
          <span v-for="error in errors['password']" v-if="errors['password']" class="help-block"><strong v-text="error" /><br></span>
        </div>

        <div class="form-group">
          <label for="password-confirm">
            Confirm password
          </label>
          <input
            id="password-confirm"
            v-model="user.password_confirmation"
            name="password-confirm"
            type="password"
            class="form-control"
            required
            autocomplete="password-confirm"
          >
        </div>

        <div class="u-mt-x-large">
          <button type="submit" class="btn btn--primary">
            Register
          </button>
        </div>
      </form>
    </blob-panel>
  </div>
</template>

<script>
import { axios } from '@qlik-trial/automations-ui'

export default {
  components: { VuePassword: () => import(/* webpackChunkName: "vue-password" */'./VuePassword') },
  props: ['name', 'email', 'invitationToken', 'id'],
  data() {
    return {
      user: {
        id: this.id,
        name: this.name,
        email: this.email,
        password: '',
        password_confirmation: '',
        invitation_token: this.invitationToken,
      },
      errors: [],
      cancel: null,
    }
  },

  computed: {
    provider() {
      return window.provider
    },
  },

  methods: {
    submit() {
      axios.put('/invitation/' + this.user.id, this.user)
        .then(() => {
          window.location.href = '/'
        })
        .catch(errors => {
          this.errors = errors.response.data
        })
    },

    updateScore() {
      if (this.cancel) {
        this.cancel()
      }
    },

    formClass(name) {
      if (this.errors[name]) {
        return 'has-error'
      }
    },
  },
}
</script>
